import { Route, Routes } from "react-router-dom";
import Navbar from "./Components/Navbar/Navbar";
import Login from "./Components/Login";
import Register from "./Components/Register";
import HomeLayout from "./layout/HomeLayout";
import AddProduct from "./Components/AddProduct/AddProduct";
import ListProduct from "./Components/ListProduct/ListProduct";
import Edit from "./Components/editProduct/Edit";
import Testimonials from "./Components/Testimonials/Testimonials";
import ListTestimonials from "./Components/Testimonials/ListTestimonials";
import Logout from "./Pages/Logout";

function App() {
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/home" element={<HomeLayout />}>
          <Route index element={<AddProduct />} />
          <Route path="listproduct" element={<ListProduct />} />
          <Route path="testimonials" element={<Testimonials />} />
          <Route path="listtestimonials" element={<ListTestimonials />} />
          <Route path="edit/:id" element={<Edit />} />
        </Route>
        {/* Logout */}
        <Route path="/logout" element={<Logout />} />
      </Routes>
    </>
  );
}

export default App;
